import OrderConfirmed from './OrderConfirmed'
export default OrderConfirmed